import { CustomBreakpoint } from '../helpers/breakpoint.helper';
import { isRetinaDisplay } from '../helpers/retina-display.helper';
import { PictureResolutions } from '../models/blog-posts.model';

export const getImageResolution = (resolutions: PictureResolutions, breakpoint: CustomBreakpoint) => {
    let source: string;
    switch (breakpoint) {
        case CustomBreakpoint.SMALL: {
            source = isRetinaDisplay() ? resolutions.mq1r : resolutions.mq1;
            break;
        }
        case CustomBreakpoint.MEDIUM: {
            source = isRetinaDisplay() ? resolutions.mq2r : resolutions.mq2;
            break;
        }
        case CustomBreakpoint.LARGE || CustomBreakpoint.X_LARGE: {
            source = isRetinaDisplay() ? resolutions.mq3r : resolutions.mq3;
            break;
        }
        default:
            source = isRetinaDisplay() ? resolutions.mq3r : resolutions.mq3;
            break;
    }

    return source;
};
